import {Component, OnInit} from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {LicenseFeaturesService} from '../../../services/common/license-features/license-features.service';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {
  AnalyticsSettingsApiService
} from '../../../services/api/settings/administration/analytics-settings/analytics-settings-api.service';

@Component({
  selector: 'analytics-settings',
  templateUrl: './analytics-settings.component.html',
  styleUrls: ['./analytics-settings.component.scss']
})
export class AnalyticsSettingsComponent implements OnInit {
  canSubmit: boolean;
  isAnalyticsEnabled: boolean;

  analyticsConfiguration: any = {};

  constructor(private analyticsConfigurationApiService: AnalyticsSettingsApiService,
              private userPrivilege: UserPrivilegeService,
              private licenseFeaturesService: LicenseFeaturesService,
              private loaderService: LoaderService) {
  }

  ngOnInit(): void {
    this.canSubmit = this.userPrivilege.isAuthorized();
    this.loaderService.showMainContainer();
    this.initialization();
  }

  submit(): void {
    const params = Object.assign({}, this.analyticsConfiguration);
    delete params.userName;
    this.analyticsConfigurationApiService.updateAnalyticsConfiguration(params).subscribe((conf) => {
      this.setConfigurationValues(conf);
    });
  }

  initialization(): void {

    this.licenseFeaturesService.isFeatureSupported(
      'analyticsView').subscribe(isFeatureSupported => {
      this.isAnalyticsEnabled = isFeatureSupported;

      if (isFeatureSupported) {
        this.analyticsConfigurationApiService.getAnalyticsConfiguration().subscribe((conf) => {
          this.setConfigurationValues(conf);
          this.loaderService.hideMainContainer();
        });
      } else {
        this.loaderService.hideMainContainer();
      }
    });
  }

  setConfigurationValues(conf): void {
    this.analyticsConfiguration.userName = 'analytics';
    this.analyticsConfiguration.host1 = conf.host1;
    this.analyticsConfiguration.host2 = conf.host2;
    this.analyticsConfiguration.host3 = conf.host3;
  }
}
